<template>
  <div class="stat-menu-abc">
    <v-container fluid>
      <stat-top-filter
        :days-count="30"
        :filial-default="globalFilialId"
        @applyFilter="fetchData"
      >
        <template #additional-filter>
          <label
            class="stat-filter-col__label"
          >
            выбрать <br />
            коннекторы:
          </label>
          <connector-select v-model="connectorIds" />
          <abc-search-field v-model="search" />
        </template>
      </stat-top-filter>
      <loader v-if="loading" />
      <template v-else>
        <div class="stat-menu-abc-table">
          <v-data-table
            v-if="filteredStatisticData.length"
            fixed-header
            :headers="headers"
            :items="filteredStatisticData"
            :items-per-page="-1"
            class="statistic-datatable headers-nowrap orange-header"
            :footer-props="{ disableItemsPerPage: true }"
            :options="tableOptions"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td class="text-center">
                  {{ index + 1 }}
                </td>
                <td>
                  {{ getMenuItemId(item) }}
                </td>
                <td><menu-item-label :item="item.menuItem" /></td>
                <td><menu-item-category :item="item.menuItem" /></td>
                <td class="text-center">
                  {{ Number(item.soldCount) ? item.averagePriceFormatted : '-' }}
                </td>
                <td class="text-center">
                  {{ item.soldCount }}
                </td>
                <td class="text-center">
                  {{ item.freeCount }}
                </td>
                <td class="text-center">
                  {{ item.costFormatted }}
                </td>
                <td>
                  <div
                    v-for="channel in item.channels"
                    :key="channel.channel"
                    class="abc-channel"
                  >
                    <span class="abc-channel__label">{{ channel.label }}</span>
                    <span class="abc-channel__value">
                      {{ channel.soldCount }} шт · {{ channel.costFormatted }}
                      <template v-if="channel.freeCount">
                        · бесплатно {{ channel.freeCount }} шт
                      </template>
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div v-else class="no-data-label">
            {{ search ? 'Ничего не найдено' : 'Нет записей за выбранный период' }}
          </div>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader'
  import StatTopFilter from '@/components/stat/StatTopFilter.vue'
  import { mapGetters } from 'vuex'
  import MenuItemLabel from '@/components/stat/menu/MenuItemLabel.vue'
  import MenuItemCategory from '@/components/stat/menu/MenuItemCategory.vue'
  import ConnectorSelect from '@/components/stat/connectors/ConnectorSelect.vue'
  import AbcSearchField from '@/components/stat/menu/AbcSearchField.vue'
  import connectorsAbcApi from '@/api/statistics/connectors/abc'
  import { filterAbcItems } from '@/util/statistics/abc'

  export default {
    name: 'ConnectorsAbcAnalysis',
    components: {
      MenuItemCategory,
      MenuItemLabel,
      StatTopFilter,
      ConnectorSelect,
      AbcSearchField,
      Loader,
    },
    data () {
      return {
        showDaysCount: 30,
        loading: false,
        statisticData: [],
        search: '',
        connectorIds: [],
        tableOptions: {
          sortBy: ['cost'],
          sortDesc: [true],
        },
        headers: [
          { text: '#', value: 'id', align: 'center' },
          { text: 'ID', value: 'menuItemId', align: 'left' },
          {
            text: 'Блюдо',
            value: 'menuItemName',
            align: 'left',
            sort: (a, b) => a.toLowerCase().localeCompare(b.toLowerCase()),
          },
          { text: 'Категория', value: 'category', align: 'left' },
          { text: 'Средняя цена блюда', value: 'averagePrice', align: 'center' },
          { text: 'Продано, шт.', value: 'soldCount', align: 'center' },
          { text: 'Бесплатно, шт.', value: 'freeCount', align: 'center' },
          { text: 'Выручка', value: 'cost', align: 'center' },
          { text: 'Каналы', value: 'channels', align: 'left', sortable: false },
        ],
      }
    },
    computed: {
      ...mapGetters({
        globalFilialId: 'branches/getGlobalFilialId',
      }),
      filteredStatisticData () {
        return filterAbcItems(this.statisticData, this.search)
      },
    },
    methods: {
      getMenuItemId (item) {
        return item?.menuItem?.id
      },
      async fetchData (filter) {
        this.loading = true
        this.statisticData = []

        const payload = {
          from: filter.from,
          to: filter.to,
          connectorIds: this.connectorIds,
          filialIds: this.normalizeFilialIds(filter.filialId),
        }

        try {
          const response = await connectorsAbcApi.fetchConnectorsABCAnalysis(
            payload,
          )
          this.statisticData = response.items
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.loading = false
      },
      normalizeFilialIds (filialId) {
        if (!filialId) {
          return null
        }

        return Array.isArray(filialId) ? filialId : [filialId]
      },
    },
  }
</script>

<style lang="less" scoped>
@import 'src/assets/styles/statistic.less';

.abc-channel {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 2px 0;
  white-space: nowrap;

  &__label {
    font-weight: 600;
  }

  &__value {
    color: #6b7280;
    font-size: 13px;
  }
}

</style>
